// TODO: Remove this file and its imports if unused elsewhere. This file is deprecated
import React from "react";
import { Trans } from "@lingui/macro";
import Footer from "components/Footer/Footer";
import "./Buy.css";
import TokenCard from "components/TokenCard/TokenCard";
import buyCADIcon from "img/buy_cad.svg";
import SEO from "components/Common/SEO";
import { getPageTitle } from "lib/legacy";

export default function BuyCADCLP() {
  return (
    <SEO title={getPageTitle("Buy CLP or CAD")}>
      <div className="BuyCADCLP page-layout">
        <div className="BuyCADCLP-container default-container">
          <div className="section-title-block">
            <div className="section-title-icon">
              <img src={buyCADIcon} alt="buyCADIcon" />
            </div>
            <div className="section-title-content">
              <div className="Page-title">
                <Trans>Buy CAD or CLP</Trans>
              </div>
            </div>
          </div>
          <TokenCard />
        </div>
      </div>
    </SEO>
  );
}
